module.exports = __webpack_public_path__ + "media/images/main_slider/KMK-22ec5bd9fd80d55b8802824e7628c773.png";